import { lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import App from '../App';
import { UnknownUserRoutes } from './UnknownUserRoutes';
import { UserLoggedRoutes } from './UserLoggedRoutes';

const NotFoundPage = lazy(() => import('@/pages/notFoundError/notFound.page'));

export function Router() {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          {currentUser ? (
            <>
              <Route path="/dashboard/*" element={<UserLoggedRoutes />} />
              <Route index element={<Navigate to="/dashboard" />} />
              {/* Logado não vê login/cadastro de novo */}
              {['/login', '/cadastro', '/bemvindo-cadastro'].map((path) => (
                <Route key={path} path={path} element={<Navigate to="/dashboard" replace />} />
              ))}
              {/* Páginas públicas (evento, inscrição, pagamento, leaderboard) também para quem está logado */}
              <Route path="/*" element={<UnknownUserRoutes />} />
            </>
          ) : (
            <>
              <Route path="/*" element={<UnknownUserRoutes />} />
            </>
          )}
          <Route path="/error/404" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
